export const ADD_SUCCESS = 'Новая прошивка добавлена';
export const ADD_ERROR = 'Не удалось добавить прошивку';
